import requests from './httpService';

const SectionService = {
  getAllSection(schooleId) {
    return requests.get(`/section/list/${schooleId}`);
  },
  findSectionList(body) {
    return requests.post('/section/find', body);
  },
  addSection(body) {
    return requests.post('/section/add', body);
  },
  updateSection(body) {
    return requests.put(`/section/${body._id}`, body);
  },
  deleteSection(body) {
    return requests.delete(`/section/${body._id}`);
  },
  getSectionById(id) {
    return requests.get(`/section/${id}`);
  },
};

export default SectionService;
